/**
 * Per-block overrides of site-wide styling, expressed as CSS custom properties
 * on the block's wrapper so everything inside inherits them.
 */

import { fontFaceCss } from '../library/resolve.js';
import { blockForMedia, captionVars } from './caption.js';
import { colorVars } from './colors.js';

/**
 * @param {Object} block
 * @param {Object} [library]
 * @param {Object} [theme] - Site theme, for saved palettes
 * @returns {{ vars: Object, fontFaceCss: string }}
 */
export function blockLook(block, library, theme) {
    if (!block) return { vars: {}, fontFaceCss: '' };
    const caption = captionVars(block.caption, library);
    return {
        vars: { ...caption.vars, ...colorVars(block.colorTheme, theme) },
        fontFaceCss: caption.face ? fontFaceCss([caption.face]) : '',
    };
}

/**
 * The look of the block a file sits in, for the viewer that opens it. The
 * viewer fills the window itself, so only the colour variables carry over.
 * @param {Object} page - Page (or home) with blocks
 * @param {string} fileId
 * @param {Object} [library]
 * @param {Object} [theme]
 */
export function mediaLook(page, fileId, library, theme) {
    const look = blockLook(blockForMedia(page?.blocks, fileId), library, theme);
    const vars = Object.fromEntries(Object.entries(look.vars).filter(([name]) => name.startsWith('--')));
    return { ...look, vars };
}
